(function ($) {

    api.accessibilities = {
    
        ARIA_toggleContent: function (obj, bool) {
			$(obj).attr({'aria-expanded':bool});
		},

		Aria_controls: function (obj, controlObjId) {
			$(obj).attr('aria-controls', controlObjId);
		},

		aria_slick_arrows: function(wrap){
			wrap.find('.slick-prev').attr('aria-label', "previous slide")
			wrap.find('.slick-next').attr('aria-label', "next slide")
		}

    }

})(jQuery);